import React from "react";
import { getDirectusField } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";

function toTitleFromUnderscore(value = "") {
  if (!value) return "";
  return value
    .toString()
    .split("_")
    .filter(Boolean)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(" ");
}

export function useIndustryChoices() {
  const { data, isLoading, error } = useFetch({
    queryKey: ["industries", "type", "choices"],
    queryFn: async () => {
      const response = await getDirectusField("industries", "type");
      const choices = response?.meta?.options?.choices || [];
      // Return both list and a map for quick lookup
      const list = choices.map((c) => ({ value: c.value, text: c.text }));
      const map = list.reduce((acc, item) => {
        acc[item.value] = item.text;
        return acc;
      }, {});
      return { list, map };
    },
    staleTime: 5 * 60 * 1000,
  });

  return {
    choices: data?.list || [],
    choiceMap: data?.map || {},
    isLoading,
    error,
  };
}

export default function IndustryTypeText({
  value,
  placeholder = "",
  fallbackToFormat = true,
  className = "",
}) {
  const { choiceMap, isLoading } = useIndustryChoices();

  if (!value) return <span className={className}>{placeholder}</span>;

  const fromChoices = choiceMap[value];

  if (fromChoices) {
    return <span className={className}>{fromChoices}</span>;
  }

  if (fallbackToFormat) {
    return <span className={className}>{toTitleFromUnderscore(value)}</span>;
  }

  return <span className={className}>{isLoading ? placeholder : value}</span>;
}
